import type { ReactNode } from 'react'
import '@/styles/record.css'

/**
 * Строка ключевых фактов записи (CompRecord.dc.html).
 *
 * Одна строка из четырёх-пяти чисел вместо групп полей «Общее / Деньги / Служебное»:
 * на карточку смотрят, чтобы решить, что делать дальше, а для этого нужны сумма, срок и
 * ответственный, а не все колонки таблицы. Полный набор полей остаётся в панели сведений.
 */
export interface Fact {
  id: string
  label: ReactNode
  value: ReactNode
  /** Пояснение под значением: «взвеш. …», «через 21 дн.», флаг просрочки. */
  sub?: ReactNode
}

export function Facts({ items, ariaLabel }: { items: Fact[]; ariaLabel?: string }) {
  if (items.length === 0) return null
  return (
    <dl className="facts" aria-label={ariaLabel} style={{ margin: 0 }}>
      {items.map((fact) => (
        <div key={fact.id} className="fact">
          <dt className="k">{fact.label}</dt>
          <dd className="v" style={{ margin: 0 }}>
            {fact.value}
          </dd>
          {fact.sub && (
            <dd className="s" style={{ margin: 0 }}>
              {fact.sub}
            </dd>
          )}
        </div>
      ))}
    </dl>
  )
}
